import * as types from 'constants/ActionTypes';

const initState = {
  loading: true,
  reportId: '',
  loadError: false,
  reportFacets: [],
  reportDetails: {},
  notFound: false,
  topImage: '',
  standardLineDiagram: '',
  updatedReportFileId: '',
  editPitchStatus: '',
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case types.LOADING_PITCH_EDITOR_PAGE: return {
      ...state,
      notFound: false,
      loading: true,
      loadError: false,
    };
    case types.LOAD_PITCH_EDITOR_PAGE_SUCCESS: return {
      ...state,
      reportId: action.reportId,
      reportDetails: action.reportDetails,
      reportFacets: action.reportFacets,
      ...action.reportImageFiles,
      loading: false,
    };
    case types.LOAD_PITCH_EDITOR_PAGE_ERROR: return { ...state, loadError: true, loading: false };
    case types.UPDATE_FACET_PITCH: return {
      ...state,
      reportFacets: state.reportFacets.map((facet) => (facet.facetId === action.facetId ? { ...facet, pitch: action.value } : facet)),
    };
    case types.UPDATE_ALL_FACETS_PITCH: return { ...state, reportFacets: state.reportFacets.map((facet) => ({ ...facet, pitch: action.value })) };
    case types.CLEAR_PITCH_EDITOR_PAGE: return initState;
    case types.UPDATE_PITCH_STATUS: return { ...state, editPitchStatus: action.editPitchStatus, updatedReportFileId: action.updatedReportFileId };
    case types.PITCH_EDITOR_NOT_FOUND: return {
      ...state, notFound: true, loading: false, loadError: false,
    };
    default:
      return state;
  }
};
